<div class="input-group">
    <button class="btn stepper-btn" type="button" [disabled]="isIncDisabled()" (click)="dec()">-</button>
    <input
        type="number"
        [formControl]="numberStepperControl"
        [step]="model.options.step"
        class="form-control input-md"
        paceCoreValidationMessage
        [validation]="numberStepperControl"
        [attr.aria-label]="ariaLabel"
    />
    <button class="btn stepper-btn" type="button" [disabled]="isDecDisabled()" (click)="inc()">+</button>
</div>
